import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './footer.component';
import { GenericListComponentModule, PipesModule } from 'octali-lib-utils';

@NgModule({
  declarations: [
    FooterComponent,  
  ],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    GenericListComponentModule
  ],
  providers: [
  
  ],
  exports: [
    FooterComponent
  ],
  entryComponents: [],
})
export class FooterComponentModule { }
